export default function getStoreDrop(store) {
  const drop = structuredClone(store.drop || {})
  // This field does not yet exist in the database,
  /// adding it here for demonstration purposes
  drop['tax_number'] = "GST-ABC-123"
  return drop
}